const translations = {
  "en": {
    "Save Chat": "Save Chat",
    "Share Session": "Share Session"
  },
  "zh-tw": {
    "Save Chat": "儲存聊天",
    "Share Session": "分享會話"
  }
};

export default translations;
